import { combineReducers } from "redux";

import emailLoginReducer from "./EmailLoginReducer";
import loginReducer from "./LoginReducer";
import setPasswordReducer from "./SetPasswordReducer";
import operationsReducer from "./OperationsReducer";
import appReducer from "./AppReducer";
import impersonateReducer from "./ImpersonateReducer";
import siteSetupReducer from "./SiteSetupReducer";
import userReducer from "./UserReducer";
import productReducer from "./ProductReducer";
import organizationReducer from "./OrganizationReducer";
import personnelReducer from "./PersonnelReducer";
import linkExpiredReducer from "./LinkExpiredReducer";
import settingsReducer from "./SettingsReducer";
import profileReducer from "./ProfileReducer";
import bannersReducer from "./BannersReducer";

const rootReducer = combineReducers({
    loginState: loginReducer,
    emailLoginState: emailLoginReducer,
    setPasswordState: setPasswordReducer,
    operationResult: operationsReducer,
    appState: appReducer,
    impersonateState: impersonateReducer,
    siteSetupState: siteSetupReducer,
    userState: userReducer,
    productState: productReducer,
    organizationState: organizationReducer,
    personnelState: personnelReducer,
    linkExpiredState: linkExpiredReducer,
    settingsState: settingsReducer,
    profileState: profileReducer,
    bannersState: bannersReducer
});

export default rootReducer;
